import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDonetions, getDonetionsByPage } from "../../helper/BackendHelper";


const DonetionInitialLoad = createAsyncThunk(
    //action type string
    "donetion/initial",
    // callback function
    async (data, thunkAPI) => {
        const response = await getDonetions();
        if (response?.status === 500) {
            return thunkAPI.rejectWithValue("Server Error");
        } else {
            if (response?.data) {
                return response.data;
            }
        }
    }
);

const DonetionPaggination = createAsyncThunk(
    //action type string
    "donetion/paggination",
    // callback function
    async (data, thunkAPI) => {



        const response = await getDonetionsByPage(data);


        // console.log({ res });

        if (response?.status === 500) {
            return thunkAPI.rejectWithValue("Server Error");
        } else {
            if (response?.data) {


                return response.data;
            }
        }
    }
);



export { DonetionInitialLoad, DonetionPaggination }